import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=a809001c"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=a809001c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports